import { FilterFn } from '../../../components/table/interfaces/FilterFn';
import { TransactionsDateFilterState } from './TransactionsDateFilterState';
import { Transaction } from '../../types/Transaction';
import { getTransactionPropertiesGroup } from './getTransactionPropertiesGroup';
import { TransactionPropertiesGroup } from './TransactionPropertiesGroup';
import { filterTransactionByProperties } from './filterTransactionByProperties';

export function createTransactionsDateFilterFunction(
  group: TransactionPropertiesGroup,
): FilterFn<Transaction, TransactionsDateFilterState> {
  return (transaction: Transaction, state: TransactionsDateFilterState) =>
    filterTransactionByProperties(getTransactionPropertiesGroup(transaction, group), state);
}
